/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
// import 'es6-promise/auto'
import './bootstrap';
import Vue from 'vue';
import AppLayout from '@/components/Layouts/AppLayout.vue'
import VeeValidate from 'vee-validate';
import store from '@/plugins/store';
import router from '@/plugins/router';
import api from "@/api";
import vuetify from '@/plugins/vuetify';
import OnLoad from '@/modules/onload.module';
import VideoBg from 'vue-videobg';
import VueMeta from 'vue-meta'
import 'lang.js';
import VueLang from '@eli5/vue-lang-js'
// get the data source
import translations from './vue-translations.js';
import { LiveRegionPlugin } from '@/utils/live-region.utils.js';
import '@/utils/accessibility.utils.js'; // Initialize global accessibility utilities

Vue.use(VueLang, {
  messages: translations, // Provide locale filelocale
  locale: localStorage.getItem('locale-goz') || 'en',
  fallback: window.fallback_locale // Set fallback lacale
});

window.Vue = Vue;

window.Vue.use(VeeValidate, {
    inject: false
})

Vue.use(VueMeta)
Vue.use(api)
Vue.use(LiveRegionPlugin)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Single comp - Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// global components
Vue.component('BackgroundVideo', VideoBg);
Vue.component('AppLayout', AppLayout)

const onLoad = new OnLoad();
export const app = onLoad
    .initApp()
    .then(() => onLoad.refresh())
    .then(() =>
        new Vue({
            router,
            store,
            vuetify,
        })).then((app) => app.$mount('#app'));
